import { render, staticRenderFns } from "./AcademyTextLeftModal.vue?vue&type=template&id=07c056cb&scoped=true&"
import script from "./AcademyTextLeftModal.vue?vue&type=script&lang=js&"
export * from "./AcademyTextLeftModal.vue?vue&type=script&lang=js&"
import style0 from "./AcademyTextLeftModal.vue?vue&type=style&index=0&id=07c056cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c056cb",
  null
  
)

export default component.exports